export const INULA_PRIVATE_PROPS = ['children', 'hooks', 'ref'];
